// features/cart/components/cart-content-skeleton.tsx
import { Separator } from "@/components/ui/separator"
import { Skeleton } from "@/components/ui/skeleton"

import { CartItemSkeleton } from "./cart-item-skeleton"

export function CartContentSkeleton() {
  return (
    <div className="flex flex-col h-full">
      {/* Header Skeleton */}
      <div className="p-4 border-b">
        <Skeleton className="h-6 w-1/3" /> {/* Title: "Giỏ hàng" */}
      </div>

      {/* Body Skeleton */}
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        <Skeleton className="h-5 w-1/2 mb-4" /> {/* Restaurant Name */}
        {Array.from({ length: 3 }).map((_, index) => (
          <CartItemSkeleton key={index} />
        ))}
      </div>

      {/* Footer Skeleton */}
      <div className="p-4 border-t space-y-3 mt-auto">
        <div className="flex justify-between">
          <Skeleton className="h-4 w-1/4" /> {/* Subtotal Label */}
          <Skeleton className="h-4 w-1/4" /> {/* Subtotal Value */}
        </div>
        <div className="flex justify-between">
          <Skeleton className="h-4 w-1/3" /> {/* Delivery Fee Label */}
          <Skeleton className="h-4 w-1/4" /> {/* Delivery Fee Value */}
        </div>
        <Separator />
        <div className="flex justify-between">
          <Skeleton className="h-5 w-1/4" /> {/* Total Label */}
          <Skeleton className="h-5 w-1/3" /> {/* Total Value */}
        </div>
        <Skeleton className="h-10 w-full rounded-lg" /> {/* Checkout Button */}
      </div>
    </div>
  )
}
